import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

@Component({
  selector: 'hdi-help-disruptor-loader',
  standalone: true,
  imports: [CommonModule, NgxSkeletonLoaderModule],
  templateUrl: './help-disruptor-loader.component.html',
  styleUrls: ['../help-disruptor.component.scss'],
})
export class HelpDisruptorLoaderComponent {}
